// lotoro-interface/src/utils/logger.js
export async function logFrontendError(message, stack = '') {
  try {
    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/log-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, stack }),
    });
  } catch (e) {
    console.warn('Frontend log failed:', e);
  }
}
